/******************************************************************************
 * Created Date: Monday April 11th 2022                                       *
 * Author: Sean W.                                                            *
 * -----                                                                      *
 * Last Modified: Mon Apr 11 2022                                             *
 * Modified By: Jan A.                                                        *
 * -----                                                                      *
 * File: /src/selectors/CameraSelector.ts                                     *
 * Copyright (c) 2020 Kuva                                                    *
 ******************************************************************************/

import compose from "lodash/fp/compose";
import sortBy from "lodash/fp/sortBy";

export const getOrgCameras = orgIds => state => {
  const filterByOrg = cameras =>
    cameras.filter(
      camera => orgIds?.includes("all") || orgIds?.includes(camera.orgUUID)
    );

  const select = compose(
    filterByOrg,
    sortBy(({ name }) => name.toLowerCase())
  );

  return select(state.cameras);
};
